import Vue from 'vue'
import Vuex from 'vuex'
import { plvPPTPlayer } from '../plvPPTPlayer'
// import {
//   isJson
// } from '@/utils/util'
Vue.use(Vuex)

const state = {
  plvIsReady: false, // 是否连接成功
  channelId: '', // 当前频道号
  currentConversation: {}, // 当前聊天对话信息
  plvCurrentMessageList: [], // 当前聊天消息列表
  plvNextReqMessageID: '', // 当前聊天记录id
  chatUser: null
}

const mutations = {
  setIsReady: (state, payload) => {
    state.plvIsReady = payload
  },
  update(state, payload) {
    for (const key in payload) {
      Vue.set(state, key, payload[key])
    }
  },
  // push聊天记录
  pushCurrentMessageList: (state, payload) => {
    state.plvCurrentMessageList.push(payload)
  },
  // unShift聊天记录
  unShiftCurrentMessageList: (state, payload) => {
    state.currentMessageList.unshift(payload)
  },
}
const actions = {
  async playerPPTInit({ commit }, params) {
    const { channelId, elDom, userInfo, vid } = params
    await plvPPTPlayer.playerPPTInit(channelId, elDom, userInfo, vid)
    commit('setIsReady', true)
    commit('update', { channelId: channelId })
    commit('update', { chatUser: userInfo })
    await plvPPTPlayer.getHistory(state.plvNextReqMessageID)
  },
  plvSendMessage({ commit }, msg) {
    plvPPTPlayer.sendMsg(msg)
  },
  joinChannel({ commit }) {
    plvPPTPlayer.joinChannel()
  },
  cancelJoinChannel() {
    plvPPTPlayer.cancelJoinChannel()
  },
  onMessageEvent({ commit }, message) {
    const messageFommater = actions.formatterMessage(message)
    if (messageFommater) {
      commit('pushCurrentMessageList', messageFommater)
    }
  },
  formatterMessage(message) {
    let chatMess = null
    chatMess = actions.formmaterMsgBase(message)
    if (message && message.EVENT) {
      switch (message.EVENT) {
        case 'SPEAK': break
        default:
          chatMess = null
          break
      }
      if (message.user) {
        switch (message.user.userType) {
          case 'teacher':
            chatMess.isTeacher = 1
        }
      }
    }
    return chatMess
  },
  formmaterMsgBase(message) {
    if (!message) {
      return null
    }
    const chatMess = message
    if (message.values && message.values.length > 0) {
      chatMess.messBody = message.values[0]
    }
    chatMess.messBody = chatMess.messBody || message.content
    if (message.user) {
      chatMess.fromId = message.user.userId
      chatMess.fromPhoto = message.user.pic
      chatMess.fromName = message.user.nick
    }

    return chatMess
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
